import React from 'react';
import './App.css';
import './css/common.css';

import Router from './Router'

function App() {
    return (
        <div className="wrapper">
            <Router />
        </div>
    );
}

export default App;
